export enum AssetType {
    EQUITY = 'us_equity',
    CRYPTO = 'crypto',
    CASH = 'cash',
}
export enum PositionSideType {
    SHORT = 'short',
    LONG = 'long'
}